import bbcode from "refractor/bbcode";
export default bbcode;